import { ca } from '@cian/analytics';

import { getNewbuildingProduct } from '../../utils/analytics';
import { IPromoInfo } from '../../types/newbuilding/promoInfo';

export function trackGetOnlineClick(promo: IPromoInfo, position: number, newbuildingId: number) {
  const { promoType, promoId, uniquePromoId } = promo;

  ca('eventSite', {
    action: 'click_get_online',
    category: 'Promo',
    label: promoType,
    name: 'oldevent',
    products: [
      getNewbuildingProduct({ newbuildingId, extra: { promoId, promoCianMortgage: uniquePromoId, position } }),
    ],
  });
}
